export default import.meta.ROLLDOWN_FILE_URL_5P2uCGnqUH$YlKA7ypPFDQ